var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Loader2 } from 'lucide-react';
import { Button } from './button';
/**
 * Button component with built-in loading state management.
 * Automatically handles spinner display, text switching, and icon management.
 * Automatically disables the button when isLoading is true or when disabled is true.
 */
export var ButtonLoadingSpinner = function (_a) {
    var isLoading = _a.isLoading, text = _a.text, loadingText = _a.loadingText, icon = _a.icon, children = _a.children, disabled = _a.disabled, buttonProps = __rest(_a, ["isLoading", "text", "loadingText", "icon", "children", "disabled"]);
    // Disable button if explicitly disabled OR if loading
    var isDisabled = disabled || isLoading;
    return (<Button {...buttonProps} disabled={isDisabled}>
      {isLoading && <Loader2 className="h-4 w-4 animate-spin"/>}
      {!isLoading && icon}
      {isLoading ? (loadingText !== null && loadingText !== void 0 ? loadingText : text) : text}
      {children}
    </Button>);
};
